define((require) => {
    "use strict";

    var {isString, defer}   = require("underscore"),
        $                   = require("jquery"),
        {rtrim}             = require("shared/util/StringUtils");

    return {

        /**
         * Set focus in the end of the input field. It is used when the user click on
         * the pencil image.
         * @param {Jquery} $el Element that will be placed the focus
         */
        setCaretEndPosition: function($el) {
            if ($el && $el.length > 0) {
                var el = $el.get(0),
                    maxScrollLeft = el.scrollWidth - el.clientWidth;

                // It is needed to be called after the click event.
                // Otherwise, It won't have effect.
                defer(() => {
                    el.focus();

                    $el.scrollLeft(maxScrollLeft);

                    if (typeof window.getSelection !== "undefined" && typeof document.createRange !== "undefined") {
                        var range = document.createRange();

                        range.selectNodeContents(el);

                        range.collapse(false);

                        var sel = window.getSelection();

                        sel.removeAllRanges();

                        sel.addRange(range);
                    } else if (typeof document.body.createTextRange !== "undefined") {
                        var textRange = document.body.createTextRange();

                        textRange.moveToElementText(el);

                        textRange.collapse(false);

                        textRange.select();
                    }
                });
            }
        },

        /**
         * Check if the text-overflow: ellipsis  is activated for the input field
         *
         * @param   {Object}    field object.
         *
         * @returns {Boolean}   Returns a boolean if the element needs the Ellipsis feature
         */
        isEllipsisActive: function(field) {
            var returnVal = false,
                text = field.val(),
                $input = field.input,
                css = $input.css(["fontSize", "fontWeight", "fontFamily"]), // TODO: broken! does not seem to properly take margin/padding/border into account!
                $tmp = $("<span>", {text: text, css: css}),
                input = $input.get(0);

            $("body").append($tmp);

            if ($input.is("input") && $input.width() < $tmp.width()) {
                returnVal = true;
            } else if (input.offsetWidth < input.scrollWidth) {
                returnVal = true;
            }

            $tmp.remove();

            return returnVal;
        },
        /**
         * Remove some &nbsp; or &amp; chars from the final string. It will
         * double check the $().text() function and be sure that any dirty html
         * will come in the middle.
         *
         *
         * OBS1: It can't use the underscore htmlUnescape function, because the underscore function
         * will remove all htmls tags.
         *
         * @param {String} val The value that will sanitized
         * @returns {*}
         */
        sanitize: function(val) {
            if (isString(val)) {
                val = rtrim(val);

                val = val.replace(/&nbsp;/g, " ");

                val = val.replace(/&amp;/g, "&");
            }

            return val;
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/behaviors/EditBehaviorUtil.js